import styled from 'styled-components';
import Counter from './Counter';

const Container = styled.h2`
    font-size: 26px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.41;
    letter-spacing: normal;
    text-align: left;
    color: #707070;
    padding-top: 3rem;
`;

type Props = {
    category: ContestCategory;
    categoryVotes?: number;
};

export const CategoryTitle = ({ category, categoryVotes }: Props) => {
    const votesLeft = category.maxVotes - categoryVotes;
    const showVotesCounter = category.maxVotes > 1;
    return (
        <Container>
            {category.name}
            {showVotesCounter && <Counter votesLeft={votesLeft} />}
        </Container>
    );
};

export default CategoryTitle;
